<template>
  <doctor-schedule :doctor="doctor" @update="onUpdate"/>
</template>

<script>
import DoctorSchedule from "@/components/settings/doctor/v2/DoctorSchedule.vue";

export default {
  name: "DoctorScheduleSection",

  components: { DoctorSchedule },

  props: {
    doctor: {
      type: Object,
      required: true,
    },
  },

  methods: {
    onUpdate(payload) {
      this.$emit("update", payload);
    },
  },
};
</script>
